<template>
    <div>
        <div class="jumbotron">
            <h1 class="display-4">Welcome to Delivery Hub</h1>
            <p class="lead">You a delivery company or You deliver as an individual? <router-link to="/trips/-1">Add trip</router-link> or <router-link to="/dashboard">Track trips</router-link>
            or  <router-link to="/trip-reports">Pull reports</router-link></p>
            <p class="lead" v-if="!user.email">Please <router-link to="/register">register</router-link> or <router-link to="/login">login</router-link> to start tracking your trips</p>

            <hr/>
        </div>
        <Slider />

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Slider from "./commons/slider";

    export default {
        name: "home",
        components: {Slider},
        computed: {
            ...mapState({
                user: state => state.globalStore.user,
            })
        }
    }
</script>

<style scoped>

</style>
